import { PageContent, PageWrapper } from './main-templateStyles';
import Footer from '../../pages/landing/components/Footer/Footer';
import TopBar from '../../pages/landing/components/TopBar/TopBar';
import { useRef } from 'react';
import { SectionRefs } from '../../pages/landing/types/navigation';
import { useWindowWidth } from '../../../hooks/useWindowWidth';
import MobileMenu from '../../pages/landing/components/MobileMenu/MobileMenu';

export const MainTemplate = (props: any) => {
  const width = useWindowWidth();
  const sectionRefs: SectionRefs = {
    WHYOCA: useRef<HTMLDivElement>(null),
    FAQS: useRef<HTMLDivElement>(null),
    BLOG: useRef<HTMLDivElement>(null),
    CONTACT: useRef<HTMLDivElement>(null),
  };
  return (
    <PageWrapper>
      {width >= 768 && <TopBar sectionRefs={sectionRefs} />}
      {width < 768 && <MobileMenu sectionRefs={sectionRefs} />}
      <PageContent>
        <>{props.children}</>
      </PageContent>
      <Footer />
    </PageWrapper>
  );
};
